/* Sorenzia winter layer (20 Oct 2026): scroll reveals. */
(function () {
  'use strict';
  if (window.__szWinter) return;
  window.__szWinter = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var main = document.getElementById('MainContent');
  if (!main) return;

  /* ---------- Reveal on scroll ---------- */
  var REVEAL = [
    '.sz-section-head',
    '.sz-tile',
    '.sz-editorial__media',
    '.sz-editorial__content',
    '.sz-faq__head',
    '.sz-faq__item',
    '.product-list .section-resource-list__content',
    '.product-list .resource-list__item',
    '.product-list .product-grid__item'
  ].join(',');

  if (!reduce && 'IntersectionObserver' in window) {
    var vh = window.innerHeight;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    main.querySelectorAll(REVEAL).forEach(function (el) {
      if (el.closest('.sz-section--hero') || el.classList.contains('sz-rv')) return;
      if (el.getBoundingClientRect().top < vh * 0.92) return; /* already on screen: leave as is */
      var sibs = el.parentElement ? Array.prototype.filter.call(el.parentElement.children, function (c) { return c.matches(REVEAL); }) : [el];
      var i = Math.max(0, sibs.indexOf(el));
      el.style.setProperty('--rd', Math.min(i % 4, 3) * 0.09 + 's');
      el.classList.add('sz-rv');
      io.observe(el);
    });
  }

})();
